import React from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Container, ExportWrapper, HeadingText, NftDetails, NftDetailsWrapper, NftHeadingContainer, Root } from './TableStyle'

const Week = () => {
  return (
    <Root>
    {/* <ExportWrapper>
      <ReactHtmlTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename="tablexls"
        sheet="tablexls"
        buttonText="Export"
      
      />
    </ExportWrapper> */}
    <Container id="table-to-xls">
      <NftHeadingContainer>
        <HeadingText>Date</HeadingText>
        <HeadingText>Sold</HeadingText>
        <HeadingText>Auctioned</HeadingText>
        <HeadingText>Royality</HeadingText>
        <HeadingText>Transaction Fees</HeadingText>
      </NftHeadingContainer>

      <NftDetailsWrapper>
        <NftDetails> 28/05/2023 </NftDetails>
        <NftDetails> Alien Gun </NftDetails>
        <NftDetails> common </NftDetails>
        <NftDetails>$10</NftDetails>
        <NftDetails>$500</NftDetails>
      </NftDetailsWrapper>
    </Container>
  </Root>
  )
}

export default Week